import transaction from '@js/store/modules/transaction';

export default {
    created() {
        if (this.$store.hasModule('transaction')) return;
        this.$store.registerModule('transaction', transaction);
    },
};
